import styled from "styled-components";
import { theme } from '../../theme'

const ModuleHeaderDiv = styled.div`
    display: flex;
    align-items:center;
    margin-bottom: 2.5rem;

    span {
        font-weight: 700;
        font-size: 1.2rem;
        letter-spacing: 1px;
        text-transform: uppercase;
        color: ${theme.colors.black};
        margin-right: 5px;
    }
`

const Hr = styled.hr`
    height: 1px;
    background-color:rgb(216 216 216 / 37%);
    flex: 1;
    border: none;
`

const ModuleHeader = ({ title }) => {
    return (
        <ModuleHeaderDiv>
            <span>{title}</span>
            <Hr />
        </ModuleHeaderDiv>
    )
}

export { ModuleHeader }
